/** Full document type strings stored in DB / sent to API */
export const STAMPED_DOCUMENT_TYPE_NY = 'New York Stamped Declarations Page(s)';
export const STAMPED_DOCUMENT_TYPE_IL = 'Illinois Countersignature Page(s)';

/** UI state codes (NY and IL stamped programs only) */
export const STAMPED_STATE_CODES = ['NY', 'IL'] as const;
export type StampedStateCode = (typeof STAMPED_STATE_CODES)[number];

export function documentTypeToStateCode(documentType: string): string {
    if (documentType === STAMPED_DOCUMENT_TYPE_IL) return 'IL';
    if (documentType === STAMPED_DOCUMENT_TYPE_NY) return 'NY';
    return '';
}

export function stateCodeToDocumentType(code: string): string {
    const c = code.trim().toUpperCase();
    if (c === 'IL') return STAMPED_DOCUMENT_TYPE_IL;
    if (c === 'NY') return STAMPED_DOCUMENT_TYPE_NY;
    return '';
}
